import React from 'react';
import { Box, Typography } from '@mui/material';

const WhyClinicSoftwareFailsArticle = () => (
    <Box>
        <Typography variant="h3" component="h1" fontWeight={700} gutterBottom sx={{ fontSize: { xs: '1.65rem', md: '2rem' } }}>
            Why Clinic Software Fails for Home Visit Teams
        </Typography>
        <Typography color="text.secondary" paragraph>
            Clinic software tracks what happens inside your facility. It has no concept of a therapist moving between five
            patient homes in a day. That's not a missing feature — it's a different workflow entirely.
        </Typography>
        <Typography variant="h2" component="h2" fontWeight={700} sx={{ fontSize: '1.35rem', mt: 4, mb: 1.5 }}>
            In-facility workflow versus multi-home routing
        </Typography>
        <Typography color="text.secondary" paragraph>
            Clinic tools assume a front desk, a fixed location, and visits that occur in rooms you control. Home rehabilitation
            assumes travel, variable environments, and sessions completed at the point of delivery. Scheduling a visit is only
            the start: you still need proof of attendance, structured notes, and a line from those visits to payroll and
            claims.
        </Typography>
        <Typography variant="h2" component="h2" fontWeight={700} sx={{ fontSize: '1.35rem', mt: 4, mb: 1.5 }}>
            Why bolt-on mobile modules often miss the point
        </Typography>
        <Typography color="text.secondary" paragraph>
            Many clinic products add a mobile app for “field” use, but the data model underneath is still clinic-centric.
            Payout and verification remain separate problems solved with exports, spreadsheets, or trust-based reporting. The
            product may check a box on an RFP without changing how month-end actually works.
        </Typography>
        <Typography variant="h2" component="h2" fontWeight={700} sx={{ fontSize: '1.35rem', mt: 4, mb: 1.5 }}>
            What to look for instead
        </Typography>
        <Typography color="text.secondary" paragraph>
            If your team lives in patients’ homes, evaluate software the way your operations actually run: routing, on-site
            capture, accountability across therapists, and whether payout numbers trace back to verified visits—not parallel
            spreadsheets. The next article walks through that evaluation in more detail.
        </Typography>
    </Box>
);

export default WhyClinicSoftwareFailsArticle;
